import { useState } from 'react';
import './Home.css';

const Home = () => {
    const [disabled, setDisabled] = useState(() => {
        try { return localStorage.getItem('navConsent') === 'true'; } catch (e) { return false; }
    });
    const [message, setMessage] = useState(null);

    const handleConsent = () => {
        const ts = Date.now();
        const info = { consent: true, ts };
        try {
            localStorage.setItem('navConsent', 'true');
            localStorage.setItem('consentInfo', JSON.stringify(info));
            window.dispatchEvent(new Event('navConsentChanged'));
            setMessage(`Consent taken on ${new Date(ts).toLocaleString()}`);
            setDisabled(true);
        } catch (e) {
            console.error('Failed to persist consent locally', e);
            setMessage('Failed to record consent locally. Please try again.');
            setDisabled(false);
        }
    };

    return (
        <div className="home-panel">
            <h2>DICOMVii</h2>
            <h3>DICOM Viewer for Development and Testing purposes</h3>
            <br />
            <div className="consent-note">
                <strong>Warning:</strong> This is a development preview and not suitable for clinical use.
                The functionality provided here is experimental and may be incomplete or unstable.
                <div className="home-message">
                    <button
                        className="btn-primary"
                        onClick={handleConsent}
                        disabled={disabled}
                    >
                        {disabled ? 'Consent recorded' : 'I Understand — Enable Navigation'}
                    </button>
                </div>
                {message && (
                    <div className="home-message">{message}</div>
                )}
            </div>
            <p className="home-help">Use the <strong><em>DICOM Web</em></strong> and <strong><em>Manual Viewer</em></strong> links in the navigation to access functionality.</p>
        </div>
    );
}

export default Home;
